import React from 'react';
import { permit } from '@lba-dev/package.local-globals/restrictions';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { connect } from 'react-redux';

import stopPropagation from '../../utils/stopPropagation';
import { setNoAssurance } from '../../actions/artisan';


const mapStateToProps = ({ connectedUser }) => ({
  user: connectedUser,
});

export default connect(mapStateToProps)(({
  user,
  artisan: { _id, noAssurance = false },
  setData = null,
}) =>
  permit(user, { key: 'chefPart' }) && (
    <FormControlLabel
      control={
        <span
          onClick={stopPropagation(() =>
            setData ? setData() : setNoAssurance(_id, !noAssurance)
          )}
          children={
            <Switch
              checked={noAssurance}
              color={noAssurance ? 'secondary' : 'primary'}
            />
          }
        />
      }
      label={
        'Le sst n\'a pas d\'assurance'
      }
    />
  ));
